<template>
  <div>
    <el-dialog title="子数据列表" :visible.sync="$store.state.cart.carDialogVisible" width="80%">
      <div>
        <el-table :data="$store.state.cart.ChildProductInfo" style="width: 100%">
          <el-table-column prop="new_productno" label="物料编码">
          </el-table-column>
          <el-table-column prop="new_product_name" label="物料描述" width="200">
          </el-table-column>
          <!-- <el-table-column prop="new_uom_name" label="单位">
          </el-table-column> -->
          <el-table-column prop="new_uom_name" label="单位" width="100" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.packageunit[0].Name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="new_qty" label="数量">
          </el-table-column>
          <el-table-column prop="new_price_typeName" label="价格类型">
          </el-table-column>
          <el-table-column label="价格">
            <template slot-scope="row">
              {{ (row.standard_price_show || 0).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="优惠价">
            <template slot-scope="row">
              {{ (row.new_price_show || 0).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="小计">
            <template slot-scope="row">
              {{ (row.rowTotalPrice || 0).toFixed(2) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <router-view style="height:100%;" :style="{background:this.$store.state.pageBackground}"></router-view>
  </div>

</template>

<script>
export default {
  mounted() {
    this.updateTableHeight();

    window.onresize = () => {
      this.updateTableHeight();
    };
  },
  methods: {
    updateTableHeight() {
      var documentHeight = document.body.clientHeight;
      this.$store.commit("UPDATE_TABLE_HEIGHT", documentHeight - 270);
    },
  },
};
</script>



// WEBPACK FOOTER //
// App.vue?20d6891c